import React from "react";

import { Text } from "./styles";

const Question = ({ question }) => <Text>{question}</Text>;

export default Question;
